<template>
	<div class="promoted-projects">
		<div class="hero-image-container">
			<img
				:src="mainPhoto && mainPhoto.objectUrl ? mainPhoto.objectUrl : require(`@/drc/assets/images/default-project-image.webp`)"
				ref="mainImage"
				alt="hero image"
				class="hero-image"
				@error="setFallback"
			/>
			<img
				:src="nextPhoto && nextPhoto.objectUrl ? nextPhoto.objectUrl : require(`@/drc/assets/images/default-project-image.webp`)"
				ref="backgroundImage"
				class="hero-image-background"
				alt="background"
				@error="setFallback"
			/>
			<div class="actions-promoted">
				<div class="project-data-container">
					<img
						class="right-arrow arrow"
						@click="increaseIndex"
						:class="currentIndex === projects.length -1 ? 'disabled' : ''"
						src="@/drc/assets/icons/arrows/arrow_right_blue.svg"
					/>
					<img
						class="left-arrow arrow"
						@click="decreaseIndex"
						:class="currentIndex === 0 ? 'disabled' : ''"
						src="@/drc/assets/icons/arrows/arrow_right_blue.svg"
					/>
					<p>{{projectIndustry}}</p>
					<h1>{{projectTitle}}</h1>
					<div
						class="dive-in-button"
						@mouseenter="stopShuffle"
						@mouseleave="startShuffle"
						@click="openUrl()"
					>
						{{$t('homePage.diveIn')}}
					</div>
				</div>
				<div :class="['featured-stories', {'top' : isOnTop}]">
					<span>{{$t('homePage.featuredStories')}}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "PromotedProjects",
	data() {
		return {
			currProject: {},
			currentIndex: 0,
			futureIndex: 0,
			shuffle: null,
		}
	},
	computed: {
		project(){
			return this.projects[this.currentIndex]
		},
		mainPhoto(){
			return this.project.projectImages.find(image => image.imageType.imageTypeLabel === "main")
		},
		nextPhoto(){
			return this.projects[this.futureIndex].projectImages.find(image => image.imageType.imageTypeLabel === "main")
		},
		projectTitle(){
			return this.project.translations.find(translation => translation.language.name === this.$i18n.locale).referenceTitle
		},
		projectIndustry(){
			return this.project.industryReference.industry.translations.find(translation => translation.language.name === this.$i18n.locale).name;
		}
	},
	methods: {
		setFallback(event) {
			console.error(`Project with id: ${this.project.id} has problem to load the its main image.`)
			event.target.src = require(`@/drc/assets/images/default-project-image.webp`);
		},
		openUrl() {
			const url = this.$router.resolve(this.generateProjectURL()).href;
			window.open(url, "_blank");
		},
		generateProjectURL() {
			let dateFormat = new Date(this.project.management.firstDatePublish);
			return `/projects/${dateFormat.getFullYear()}/${dateFormat.getMonth() + 1}/${this.project.id}`;
		},
		startShuffle() {
			this.shuffle = setInterval(() => {
				this.increaseIndex();
			}, 6000);
		},
		stopShuffle() {
			clearInterval(this.shuffle);
		},
		increaseIndex(){
			this.$refs.mainImage?.classList.add('transitioning');
			if(this.currentIndex !== this.projects.length - 1){
				this.futureIndex = this.currentIndex + 1;
			}else{
				this.futureIndex = 0;
			}
			setTimeout(() => {
				this.currentIndex = this.futureIndex
				this.$refs.mainImage?.classList.remove('transitioning');
			}, 200);
		},
		decreaseIndex(){
			this.$refs.mainImage?.classList.add('transitioning');
			if(this.currentIndex !== 0){
				this.futureIndex = this.currentIndex - 1;
			}else{
				this.futureIndex = this.projects.length - 1;
			}
			setTimeout(() => {
				this.currentIndex = this.futureIndex
				this.$refs.mainImage?.classList.remove('transitioning');
			}, 200);
		}
	},
	mounted() {
		this.startShuffle();
	},
	props: {
		projects: {
			type: Array,
			required: true
		},
		isOnTop: {
			type: Boolean,
			required: true
		}
	}
}
</script>

<style scoped lang="scss">
@import "@/common/assets/css/_variables.scss";

.promoted-projects{
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	.hero-image-container {
		width: 100%;
		height: calc(100vh - (65px + 20vh));
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;

		@media (min-resolution: 250dpi) and (max-width: 600px) and (min-aspect-ratio: 11/9) {
			height: 250vh;
		}

		.featured-stories {
			display: flex;
			position: fixed;
			top: 65px;
			width: fit-content;
			max-width: 1440px;
			height: 39px;
			font-family: Roboto, serif;
			font-weight: 400;
			font-size: 15px;
			line-height: 20px;
			letter-spacing: 0;
			background: #ffb81c;
			color: #001F33;
			text-transform: uppercase;
			align-items: center;
			padding-left: 15px;
			padding-right: 15px;
			clip-path: polygon(
					0 0,           // top-left
					100% 0,        // top-right
					100% calc(100% - 20px), // bottom-right before the cut
					calc(100% - 20px) 100%, // diagonal cut
					0 100%         // bottom-left
			);
			z-index: 1;

			span {
				width: fit-content;
			}

			&.top {
				display: none;
			}
		}

		.hero-image-background {
			position: absolute;
			min-width: 100%;
			min-height: 100%;
			height: 100%;
			opacity: 0.1;
			object-fit: cover;
			filter: brightness(0.9);
			background: #001F33;
			overflow: hidden;
		}

		.hero-image {
			min-width: 100%;
			min-height: 100%;
			height: 100%;
			transition: opacity 0.2s ease-in;
			object-fit: cover;
			filter: brightness(0.9);
			background: #001F33;
			overflow: hidden;

			&.transitioning {
				opacity: 0.1;
			}
		}

		.actions-promoted {
			max-width: 1440px;
			margin: 0 auto;
			position: absolute;
			bottom: 0;
			width: 100%;
			padding: 0;

			.project-data-container {
				position: absolute;
				background-color: white;
				color: black;
				bottom: 0;
				right: 0;
				width: min(720px, 60%);
				height: auto;
				clip-path: polygon(80px 0%, 100% 0%, 100% 100%, 0% 100%, 0% 80px);
				padding: 50px;
				z-index: 2;

				@media (max-width: 1600px) {
					height: fit-content;
					width: 45vw;
					padding: 35px 18px 18px 35px;
					clip-path: polygon(40px 0%, 100% 0%, 100% 100%, 0% 100%, 0% 40px);
				}

				@media (max-width: $tablet) {
					width: 60vw;
				}

				@media (max-width: $mobile) {
					width: 100%;
				}

				p {
					font-family: Roboto, serif;
					font-weight: 400;
					font-size: 13px;
					line-height: 18px;
					letter-spacing: 0;
					text-transform: uppercase;
					color: #636366;

					@media (max-width: 1400px) {
						margin-top: 10px;
						margin-bottom: 10px;
					}
				}

				h1 {
					font-family: Tiempos Text, sans-serif;
					font-weight: 400;
					font-size: 32px;
					line-height: 40px;
					letter-spacing: 0.37px;
					vertical-align: middle;
					color: #001F33;
					word-break: break-word;
					display: -webkit-box;
					-webkit-line-clamp: 3;
					-webkit-box-orient: vertical;
					overflow: hidden;

					@media (min-resolution: 250dpi) and (max-width: 1400px) and (min-aspect-ratio: 11/9) {
						-webkit-line-clamp: 1;
					}

					@media (max-width: 1400px) {
						margin-top: 10px;
						margin-bottom: 10px;
						font-size: 21px;
						line-height: 22px;
					}
				}

				.dive-in-button {
					width: min(200px, 100%);
					height: 54px;
					font-family: Roboto, serif;
					font-weight: 500;
					font-size: 15px;
					line-height: 20px;
					letter-spacing: 0;
					text-transform: uppercase;
					border: 1px solid #001F33;
					display: flex;
					align-items: center;
					justify-content: center;
					position: relative;
					background: linear-gradient(90deg, rgba(255,184,28,1) 50%, rgba(255,255,255,1) 50%, rgba(255,255,255,1) 100%);
					background-size: 200%;
					background-position: right;
					transition: background 0.3s ease-in;
					cursor: pointer;

					@media (max-width: 1400px) {
						height: 35px;
					}

					&::after {
						position: absolute;
						content: '';
						width: 30px;
						height: 30px;
						bottom: -15px;
						right: -15px;
						border-top: 1px solid #001F33;
						transform: rotate(-45deg);
						background: white;
					}

					&:hover {
						background-position: left;
					}
				}

				.arrow {
					position: absolute;
					top: 10%;
					right: 10%;
					height: 30px;
					width: 30px;
					cursor: pointer;

					&.left-arrow {
						transform: rotate(180deg);
						margin-right: 50px;
					}
				}
			}
		}

	}
}
</style>
